import { PageLoading } from '@ant-design/pro-layout';

export default PageLoading;
